import React, { useState, useEffect } from 'react';
import { TextField, Box, Grid, Autocomplete, Button, Typography,Paper, Divider
} from '@mui/material';
import { useSnackbar } from 'notistack';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { getConfigurations, getAllowedConfigValues, updateConfiguration } from 'services/settings/configurations';
import { useForm, Controller } from "react-hook-form";

const ConfigurationPage = () => {
  const defaultValues = {
    name: '',
    value: '',
  };

  const [configurationNames, setConfigurationNames] = useState([]);
  const [allowedConfigurationValues, setAllowedConfigurationValues] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, formState: { errors }, reset, watch, setValue } = useForm({
    mode: 'onTouched',
    defaultValues
  });

  useEffect(() => {
    loadConfigurations();
  }, []);

  function loadConfigurations() {
    getConfigurations().then(({response, error}) => {
      if(response){
        setConfigurationNames([...(response || [])]);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }
  
  const onSubmit = (data) => {
    const postData = {
      name: data?.name?.name,
      value: data?.value
    }
    saveConfigurations(postData);
  }
  const onConfigurationNameChange = (newValue) => {
    if(newValue?.name){
      getAllowedConfigurationValues(newValue?.name, newValue);
      setValue('value', '');
    }else{
      setAllowedConfigurationValues([]);
    }
  }

  const getAllowedConfigurationValues = (name, configName) => {
    getAllowedConfigValues({name}).then(({response, error}) => {
      if(response){
        setAllowedConfigurationValues([...(response || [])]);
        setValue('value', configName?.value);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const saveConfigurations = (data) => {
    updateConfiguration(data).then(({response, error}) => {
      if(response){
        reset({...defaultValues});
        enqueueSnackbar("Configurations updated successfully", {variant: 'success'});
        loadConfigurations();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      } 
    });
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Configurations
      </Typography>
      <Divider />
        <Box sx={{ mb: 2, mt:2, px: 4, }} >
          <Grid container columnSpacing={2} >
            <Grid item xs={12} sm={12} md={12} lg={10} xl={8} sx={{mb: 3}} >
              <Box sx={{ mb: 2, mt:2, px: 4 }} noValidate component="form"  onSubmit={handleSubmit(onSubmit)} >
                <Grid item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1.9}}>
                  <Controller
                    control={control}
                    name="name"
                    id="name"
                    rules={{ required: "Select configuration name" }}
                    required
                    render={({field }) => (
                      <Autocomplete
                        {...field}
                        required
                        disablePortal
                        size="small"
                        options={configurationNames}
                        fullWidth={true}
                        getOptionLabel={(option) => option?.description || option}
                        isOptionEqualToValue={(option, value) => option?.name === value?.name}
                        onChange={(event, newValue) => {field.onChange(newValue); onConfigurationNameChange(newValue)}}
                        renderInput={(params) => <TextField {...params} error={!!errors?.name} required label="Name" />}
                      />
                    )}
                    onChange={([, data]) => data}
                  />
                </Grid>
                {watch('name') && allowedConfigurationValues?.length > 0 ? (
                  <Grid item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1.9}}>
                    <Controller
                      control={control}
                      name="value"
                      id="value"
                      rules={{ required: "Select value" }}
                      render={({field }) => (
                        <Autocomplete
                          {...field}
                          options={allowedConfigurationValues}
                          size="small"
                          name="value"
                          fullWidth={true}
                          isOptionEqualToValue={(option, value) => option === value}
                          onChange={(event, newValue) => {field.onChange(newValue)}}
                          renderInput={(params) => <TextField {...params} {...field} error={!!errors?.value}  required label="Value" />}
                        />
                      )}
                      onChange={([, data]) => data}
                    />
                  </Grid>) : null}

                  {watch('name') && allowedConfigurationValues?.length === 0 ? (
                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <Controller
                        control={control}
                        name="value"
                        id="value"
                        rules={{ required: "Enter value" }}
                        render={({field}) => (
                          <TextField
                            {...field}
                            rows={5}
                            margin="normal"
                            label="Value"
                            required
                            error={!!errors?.Value}
                            size="small"
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                  ): null}
                

                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    type="submit" 
                    variant="contained"
                    sx={{ mt: 4, mb: 2 }}
                    startIcon={<ModeEditIcon />}
                    color="success"
                  >
                    Save
                  </Button>
                </Grid>
              </Box>
            </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default React.memo(ConfigurationPage);
